export default __webpack_public_path__ + "static/media/emplacement-2.a55dbc8c.svg";